import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getRequestedFeedbackData, getSharedOrReceivedFeedbackData } from 'services/continuousFeedback';

const getRequestedData = async ({ feedbackId }) => {
  try {
    const res = await getRequestedFeedbackData({
      feedbackId,
    });
    return res;
  } catch (err) {
    console.error('Error fetching  requested feedback data : ', err);
  }
  return null;
};

const getSharedOrReceivedData = async ({ postId }) => {
  try {
    const res = await getSharedOrReceivedFeedbackData({
      postId,
    });
    return res;
  } catch (err) {
    console.error('Error fetching  sharedReceived feedback data : ', err);
  }
  return null;
};

export const useRequestedFeedBackData = ({ feedbackId }) =>
  useQuery(
    [REACT_QUERY_KEYS.RequestedFeedbackFullComment, feedbackId],
    () =>
      getRequestedData({
        feedbackId,
      }),
    { enabled: Boolean(feedbackId) }
  );

export const useSharedOrReceivedFeedBackData = ({ postId }) =>
  useQuery(
    [REACT_QUERY_KEYS.SharedOrReceivedFullComment, postId],
    () =>
      getSharedOrReceivedData({
        postId,
      }),
    { enabled: Boolean(postId) }
  );
